module.exports = {
	"break-tiny": "450px",
	"break-small": "680px",
	"break-medium": "768px",
	"break-large": "1200px",
	"break-huge": "1400px",
	"break-full": "1680px",
	"icons-prevent-fill-remove": [
		"sackmesser"
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/shared-variables.json
// module id = 5
// module chunks = 0